module.exports = __webpack_public_path__ + "media/bom/no-enough-stock-8d7beb1f.png";